import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import env from "../../config/env";
import moment from "moment";
import { useSelector } from "react-redux";
import CryptoJS from "crypto-js";

const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

export const fetchLeavesData = createAsyncThunk("fetchLeavesData", async (id) => {

  const token = useSelector((state) => state.auth.token);
  let url;

  const getLeaves = CryptoJS.SHA256("/getLeaves" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12);

  // Encrypt data
  const encryptedVal = CryptoJS.AES.encrypt(id.toString(), SECRET_KEY).toString();
  const encodedId = encodeURIComponent(encryptedVal); // ✅ very important


  if (id) {
    url = `${env.backend_api_endpoint}/${getLeaves}?userId=${encodedId}`;
  }

  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      authorization: token,
    },
  });

  const resData = await response.json();

  if (resData?.data) {
    try {
      const bytes = CryptoJS.AES.decrypt(resData.data, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      resData.data = JSON.parse(decrypted); // replace encrypted data with decrypted JSON
    } catch (err) {
      console.error("Decryption error:", err);
      resData.data = null; // fallback if decryption fails
    }
  }

  console.log(resData, "hgjhgvjhw")

  // Return the full response (status, message, and decrypted data)
  return resData;
});

const LeaveSlice = createSlice({
  name: "getLeaves",
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
  },
  extraReducers: (builder) => {
    builder.addCase(fetchLeavesData.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchLeavesData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchLeavesData.rejected, (state, action) => {
      state.isError = true;
    });
  },
});

export default LeaveSlice.reducer;
